
<template>
  <v-container fluid class="px-5 pt-3">
    <v-row class="pa-3" align='center'>
      <span class="title font-weight-bold">{{ $t('tasks.tasks') }}</span>
      <v-spacer></v-spacer>
      <v-btn color="primary" elevation="0" small class="text-capitalize font-weight-bold" style="border-radius: 5px;" :to="{name: 'NewTask'}" >
        <v-icon left small>mdi-plus</v-icon>
        {{ $t('tasks.task') }}
      </v-btn>
    </v-row>

    <task-list class="mt-5"></task-list>

    <router-view></router-view>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import TaskList from '../../components/tasks/TaskList.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'TaskListPage',
  //mixins: [ validations ],
  components: {
    TaskList
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>